import { FC } from 'react';

import Button, { StyleTypes } from '../../../Button';

import { ModalActions } from '../../styles';

import { Props } from './types';

const FormActions: FC<Props> = ({
  submitLabel = 'Submit',
  submitting,
  onCancel,
}) => (
  <ModalActions>
    <Button
      label="Cancel"
      styleType={StyleTypes.outlined}
      disabled={submitting}
      onClick={onCancel}
    />
    <Button
      label={submitLabel}
      styleType={StyleTypes.filled}
      type="submit"
      loading={submitting}
      disabled={submitting}
    />
  </ModalActions>
);

export default FormActions;
